import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

export const getChartsInfo = async () => {
  try {
    const res = await api.get("/chart/chartInfo");
    return res;
  } catch (err) {
    return err.response;
  }
};
